import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  url, 
  image,
  imageAlt = 'Lown mortgage calculator app interface',
  type = 'website',
  siteName = 'Lown',
  twitterHandle,
  twitterCard = 'summary_large_image',
  structuredData 
}) => {
  const siteTitle = 'Lown - Mortgage Calculator & Loan Management App';
  const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;
  const defaultDescription = 'Lown helps first-time homebuyers plan smarter with mortgage calculators, savings tracking, loan comparisons, and privacy-first insights—completely free and ad-free.';
  const defaultUrl = 'https://www.lown.app';
  const defaultImage = 'https://www.lown.app/lown_homescreen.png';
  const canonicalUrl = url || defaultUrl;
  const metaDescription = description || defaultDescription;
  const openGraphImage = image || defaultImage;
  const schemaItems = Array.isArray(structuredData)
    ? structuredData
    : structuredData
      ? [structuredData]
      : [];

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={metaDescription} />
      {keywords && <meta name="keywords" content={keywords} />}

      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={canonicalUrl} />
      {openGraphImage && (
        <>
          <meta property="og:image" content={openGraphImage} />
          <meta property="og:image:alt" content={imageAlt} />
        </>
      )}

      {/* Twitter */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      {openGraphImage && <meta name="twitter:image" content={openGraphImage} />}
      {twitterHandle && <meta name="twitter:site" content={twitterHandle} />}

      {/* Structured Data */}
      {schemaItems.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO; 
